import Avatar from "./Avatar";

export const OverlappingAvatars = ({ users }: { users: any[] }) => {
    return (
      <div className="flex items-center justify-center -space-x-2">
        {users &&
          users.map((user: any, id: number) => (
              <Avatar
                key={user.id ?? user.playerId + id}
                firstName={user.firstName}
                lastName={user.lastName}
                imageUrl={`/api/static/images/${user.profilePicture}`}
                className="size-8 ring-2 ring-white dark:ring-zinc-900 rounded-full"
              />
          ))}
      </div>
    );
  };